import { bool } from '../../component/prop-types/index.js';
import { ValidatorType } from './model-service-constants.js';
import { ValidationRunner } from './validation-runner.js';
const DEFAULT = {
    format: (value) => value,
    getPattern: () => '',
    parse: (value) => value,
    validate: () => [{
            message: '',
            name: 'default-formatter-validator',
            type: ValidatorType.DEFAULT,
            valid: true,
        }],
};
const DEFAULT_VALIDATOR_OPTION_TYPES = {
    runOnFocus: bool,
    showWhenValid: bool,
};
function modelServiceError(message) {
    return new Error(`[Model Service]: ${message}`);
}
function createModelService() {
    const FORMATTERS = new Map();
    const VALIDATORS = new Map();
    const getFormatter = (name) => {
        return FORMATTERS.get(name) ?? DEFAULT;
    };
    const getValidator = (name) => {
        const formatter = FORMATTERS.get(name);
        if (formatter) {
            return formatter.validate;
        }
        return VALIDATORS.get(name) ?? DEFAULT.validate;
    };
    const getFormatters = () => {
        return Array.from(FORMATTERS.keys());
    };
    const getValidators = (exclusive) => {
        const validators = Array.from(VALIDATORS.keys());
        return exclusive ? validators : validators.concat(getFormatters());
    };
    const getFormatterPattern = (name) => {
        const formatter = getFormatter(name);
        return String(formatter.getPattern());
    };
    const registerFormatter = (name, formatter) => {
        if (FORMATTERS.has(name)) {
            throw modelServiceError(`There's already a formatter registered with '${name}' name.`);
        }
        FORMATTERS.set(name, formatter);
        return formatter;
    };
    const registerValidator = (name, validator) => {
        if (VALIDATORS.has(name)) {
            throw modelServiceError(`There's already a validator registered with '${name}' name.`);
        }
        validator.optionTypes = {
            ...validator.optionTypes,
            ...DEFAULT_VALIDATOR_OPTION_TYPES,
        };
        VALIDATORS.set(name, validator);
        return validator;
    };
    const format = (name, value, options) => {
        const formatter = getFormatter(name);
        return formatter.format(value, options);
    };
    const formatProps = (props, keys, formatters) => {
        const filteredProps = Object.entries(props)
            .filter(([key]) => keys.includes(key))
            .reduce((accumulator, [key, value]) => ({ ...accumulator, [key]: value }), {});
        if (!formatters) {
            return filteredProps;
        }
        return Object.entries(filteredProps)
            .filter(([key]) => key in formatters)
            .reduce((accumulator, [key, value]) => {
            const formatter = getFormatter(formatters[key].name);
            const newValue = formatter.format(value, formatters[key].options);
            return { ...accumulator, [key]: newValue };
        }, filteredProps);
    };
    const parse = (format, value, options) => {
        const formatter = getFormatter(format);
        return formatter.parse(value, options);
    };
    const validate = (value) => {
        return new ValidationRunner(value);
    };
    return {
        format,
        formatProps,
        getFormatter,
        getFormatterPattern,
        getFormatters,
        getValidator,
        getValidators,
        parse,
        registerFormatter,
        registerValidator,
        validate,
    };
}
const ModelService = createModelService();
export { ModelService, };
//# sourceMappingURL=model-service.js.map